import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API = '/api';

export function useConversationSearch(selectedKB) {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredConversations, setFilteredConversations] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);

  const handleSearchConversations = useCallback(async (query) => {
    setSearchQuery(query);
    if (!query.trim() || !selectedKB) {
      setFilteredConversations([]);
      setShowSearchResults(false);
      return;
    }

    try {
      const response = await axios.get(`${API}/conversations/${selectedKB.id}`);
      const filtered = response.data.filter((conversation) =>
        conversation.title.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredConversations(filtered);
      setShowSearchResults(true);
    } catch {
      setFilteredConversations([]);
      setShowSearchResults(false);
      toast.error('Recherche de conversations indisponible');
    }
  }, [selectedKB]);

  const handleOpenConversation = useCallback((targetConversationId) => {
    setShowSearchResults(false);
    navigate(`/dashboard?conv=${targetConversationId}`);
  }, [navigate]);

  return {
    searchQuery,
    filteredConversations,
    showSearchResults,
    handleSearchConversations,
    handleOpenConversation,
  };
}
